// Global State variables that are imported by the rest of the application
export const appState = {
    exchangeRatesCache: { 'VND': 1 },
    currentTransactionsList: [],
    
    // Form state from the transaction modal
    formState: {
        wallet: { id: null, name: 'Select...', currency: 'VND' },
        walletTo: { id: null, name: 'Select...', currency: 'VND' },
        category: { id: null, name: 'Select...' },
        tag: { id: null, name: 'Optional...' }
    },

    currentTxnType: 'expense',
    editingTxnId: null,

    // Filter state for Transactions tab
    filterState: {
        keyword: '',
        type: 'all',         // 'all' | 'income' | 'expense' | 'transfer'
        walletId: null,
        useDateRange: false,
        dateFrom: null,
        dateTo: null,
        categoryIds: [],     // [] = all
        tagIds: [],          // [] = all
    }
};


// Dispatch a UI update (simplification using CustomEvent for a reactive feel)
export function dispatchStateEvent(eventName, detail = {}) {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
}
